import { render } from "./BtnPlanBlackFriday.vue?vue&type=template&id=1df7686a&scoped=true&ts=true&lang=html"
import script from "./BtnPlanBlackFriday.vue?vue&type=script&lang=ts"
export * from "./BtnPlanBlackFriday.vue?vue&type=script&lang=ts"

import "./BtnPlanBlackFriday.vue?vue&type=style&index=0&id=1df7686a&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df7686a"]])

export default __exports__